
import Accordion from "../../containers/Accordion/Accordion";
import Divider from '@material-ui/core/Divider';
import {Fragment} from 'react';

const Faq = function (props) {
    return (
        <Fragment>
            <Accordion items={props.items} 
                WpId={props.WpId}
                layout={props.layout}
                type={props.type}
                limit={props.limit}
                moreTitle={props.moreTitle} 
                openItem={props.openItem}
                handleUserKeypress = {props.handleUserKeypress}/>
               {props.layout == "second" ? <Divider /> : null } 
        </Fragment>
    );
    
}

export default Faq;